import "./SkeletonCard.css";

function SkeletonCard() {
  return (
    <div className="card_container skeleton">
      <div className="skeleton_img"></div>

      <div className="card_title_contianer">
        <div className="skeleton_title"></div>
        <div className="skeleton_desc"></div>
        <div className="skeleton_desc short"></div>
      </div>

      <div className="footer_container">
        <div className="skeleton_author"></div>
        <div className="skeleton_source"></div>
      </div>
    </div>
  );
}

export default SkeletonCard;